import api from '@pray/shared/utils/api';

import type { SaveTagLocaleParams } from './types';

/** Upserts the tag's translation for one locale (204). */
export async function saveTagLocale(tagId: string, localeCode: string, params: SaveTagLocaleParams) {
  const url = `/web/studio/tags/${tagId}/locales/${localeCode}`;

  const body = {
    name: params.name,
    description: params.description ?? null,
  };

  await api.executePutRequest(url, body);

  return { success: true };
}
